import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.shop.msdiscoveries.com/api';

const api = axios.create({ baseURL: BASE_URL });

// Attach token to every request
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('amv_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('amv_token');
      localStorage.removeItem('amv_user');
      window.location.href = '/login';
    }
    return Promise.reject(err.response?.data || err);
  }
);

// ── File upload helpers (multipart/form-data) ─────────────────
api.upload = (path, formData) =>
  api.post(path, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

api.uploadPut = (path, formData) =>
  api.put(path, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export default api;

/* ── Auth helpers ────────────────────────────────────────────── */
export const getToken  = () => localStorage.getItem('amv_token');
export const getUser   = () => { try { return JSON.parse(localStorage.getItem('amv_user')); } catch { return null; } };
export const setAuth   = (token, user) => { localStorage.setItem('amv_token', token); localStorage.setItem('amv_user', JSON.stringify(user)); };
export const clearAuth = () => { localStorage.removeItem('amv_token'); localStorage.removeItem('amv_user'); };
export const isLoggedIn = () => !!getToken();
export const hasRole    = role => { const u = getUser(); return u?.role === role; };

/* ── Formatters ──────────────────────────────────────────────── */
export const fmt = {
  currency:      (n, sym = '$') => `${sym}${parseFloat(n || 0).toFixed(2)}`,
  date:          d => new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }),
  datetime:      d => new Date(d).toLocaleString('en-IN',    { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }),
  stars:         r => { const f = Math.round(r || 0); return '★'.repeat(f) + '☆'.repeat(5 - f); },
  orderStatus:   s => ({ pending:'Pending', confirmed:'Confirmed', packed:'Packed', shipped:'Shipped', out_for_delivery:'Out for Delivery', delivered:'Delivered', cancelled:'Cancelled', returned:'Returned' }[s] || s),
  paymentStatus: s => ({ pending:'Pending', paid:'Paid', failed:'Failed', refunded:'Refunded' }[s] || s),
};

export const statusColor = s => ({
  pending:'#d97706', confirmed:'#2563eb', packed:'#7c3aed',
  shipped:'#0891b2', out_for_delivery:'#059669', delivered:'#059669',
  cancelled:'#dc2626', returned:'#6b7280',
  paid:'#059669', failed:'#dc2626',
  active:'#059669', blocked:'#dc2626'
}[s] || '#6b7280');

export const imgUrl = url =>
  url
    ? url.startsWith('http') ? url : `https://api.shop.msdiscoveries.com${url}`
    : 'https://placehold.co/400x300/e5e7eb/9ca3af?text=No+Image';
